import { useEffect, useState } from "react";
import LinkWithSearchParams from "../UI/LinkWithSearchParams";

import { HiMenu } from "react-icons/hi";
import { FiSearch } from "react-icons/fi";

import Account from "../Account/Account";
import { LANDING_ROUTE_LISTS } from "../../utils/routes";
import { FaCaretDown } from "react-icons/fa";
const LandingHeader = () => {
    const [rightMenuVisible, setRightMenuVisible] = useState(false);

    useEffect(() => {
        document.documentElement.classList.add("dark");

        function handleGroupMenuClick(element) {
            if (element.lastChild.style.maxHeight === "0px")
                element.lastChild.style.maxHeight = "100vh";
            else element.lastChild.style.maxHeight = "0px";
        }
        const cbox = document.querySelectorAll(".group-menu");

        for (let i = 0; i < cbox.length; i++) {
            cbox[i].addEventListener("click", (e) =>
                handleGroupMenuClick(cbox[i])
            );
        }
    }, []);

    return (
        <div className="fixed flex items-center md:justify-center justify-between border-b-2 border-b-white/10 w-full top-0 lg:px-8 px-4 z-10 transition-all duration-300">
            <div className="backdrop-blur-md absolute left-0 top-0 w-full h-full z-[-1]" />
            <LinkWithSearchParams
                to={{
                    pathname: "/",
                }}
            >
                <div className="home-logo my-4" />
            </LinkWithSearchParams>
            <div className="flex md:px-24 items-center gap-2">
                <div className="relative flex items-center">
                    <FiSearch className="absolute left-4 z-[-1]" size={20} />
                    <input
                        className="rounded-full pl-10 md:pl-12 text-[14px] w-12 md:w-auto focus:w-48 focus:md:w-auto duration-150"
                        placeholder="Search"
                    />
                </div>
                {LANDING_ROUTE_LISTS.map((item, index) => {
                    if (!item.nested)
                        return (
                            <LinkWithSearchParams
                                key={index}
                                to={{
                                    pathname: item.link,
                                    search: item.search,
                                }}
                                className="hidden xl:flex text-[15px] font-normal -tracking-tight items-start rounded-lg px-3 py-6 hover:text-kadGrSt duration-150"
                            >
                                {item.icon}
                                {item.title}
                            </LinkWithSearchParams>
                        );
                    else {
                        return (
                            <span
                                key={index}
                                className="hidden relative group cursor-pointer xl:flex text-[15px] font-normal -tracking-tight items-start rounded-lg px-3 py-6 hover:text-kadGrSt duration-150"
                            >
                                {item.icon}
                                {item.title}
                                <FaCaretDown className="mt-[3px] ml-0.5 duration-150 group-hover:-scale-y-100" />
                                <div className="hidden group-hover:flex flex-col fixed top-[68px] p-4 bg-kadItemDarkBg/60 backdrop-blur-md shadow-xl text-white">
                                    {item.children.map((child, index) => {
                                        if (child.external) {
                                            return (
                                                <a
                                                    className="p-4 rounded-lg flex items-center gap-6 hover:bg-[#2B3139AA] group"
                                                    key={index}
                                                    href={child.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {child.icon}
                                                    <div className="flex flex-col">
                                                        <span>
                                                            {child.title}
                                                        </span>
                                                        <span className="size-sm opacity-70">
                                                            {child.subtitle}
                                                        </span>
                                                    </div>
                                                </a>
                                            );
                                        } else
                                            return (
                                                <LinkWithSearchParams
                                                    to={{
                                                        pathname: child.link,
                                                    }}
                                                    className="p-4 rounded-lg flex items-center gap-6 hover:bg-[#2B3139AA] group"
                                                    key={index}
                                                >
                                                    {child.icon}
                                                    <div className="flex flex-col">
                                                        <span>
                                                            {child.title}
                                                        </span>
                                                        <span className="size-sm opacity-70">
                                                            {child.subtitle}
                                                        </span>
                                                    </div>
                                                </LinkWithSearchParams>
                                            );
                                    })}
                                </div>
                            </span>
                        );
                    }
                })}
            </div>
            <Account
                className="hidden md:flex"
                buttonclassname="blueGradient-button w-44 px-0 size-base font-semibold"
            />
            <HiMenu
                className="md:hidden size-3 cursor-pointer"
                onClick={() => setRightMenuVisible(!rightMenuVisible)}
            />

            <div
                className={`${
                    rightMenuVisible ? "right-0" : "-right-[100%]"
                } ace-modal flex duration-300 left-[unset]`}
            >
                {rightMenuVisible && (
                    <div
                        className="ace-modal-overlay"
                        onClick={() => setRightMenuVisible(false)}
                    />
                )}
                <div className="ace-modal-main rounded-none w-full min-h-screen mt-0">
                    <div className="ace-modal-header border-none">
                        <button
                            type="button"
                            className="ace-modal-close-button"
                            onClick={() => setRightMenuVisible(false)}
                        >
                            <svg
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div className="ace-modal-body flex flex-col">
                        <Account
                            className="flex px-6 mb-3"
                            buttonclassname="blueGradient-button w-full py-3 size-base font-semibold rounded-lg"
                        />

                        {LANDING_ROUTE_LISTS.map((item, index) => {
                            if (!item.nested)
                                return (
                                    <LinkWithSearchParams
                                        key={index}
                                        to={{
                                            pathname: item.link,
                                        }}
                                        onClick={() =>
                                            setRightMenuVisible(false)
                                        }
                                        className="flex text-[15px] font-normal -tracking-tight items-start rounded-lg px-3 py-4 hover:text-kadGrSt duration-150"
                                    >
                                        {item.icon}
                                        {item.title}
                                    </LinkWithSearchParams>
                                );
                            else {
                                return (
                                    <span
                                        key={index}
                                        className="relative group group-menu cursor-pointer text-[15px] font-normal -tracking-tight rounded-lg px-3 hover:text-kadGrSt duration-150"
                                    >
                                        <span className="flex items-start py-4">
                                            {item.icon}
                                            {item.title}
                                            <FaCaretDown className="mt-[3px] ml-0.5 duration-150 group-hover:-scale-y-100" />
                                        </span>
                                        <div
                                            className="flex overflow-hidden group-menu-panel flex-col top-[68px] bg-kadItemDarkBg/60 text-white"
                                            style={{ maxHeight: "0px" }}
                                        >
                                            {item.children.map(
                                                (child, index) => {
                                                    if (child.external) {
                                                        return (
                                                            <a
                                                                className="flex items-center py-2 gap-6 hover:bg-[#2B3139AA] group"
                                                                key={index}
                                                                href={
                                                                    child.link
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {child.icon}
                                                                <div className="flex flex-col">
                                                                    <span>
                                                                        {
                                                                            child.title
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </a>
                                                        );
                                                    } else
                                                        return (
                                                            <LinkWithSearchParams
                                                                onClick={() =>
                                                                    setRightMenuVisible(
                                                                        false
                                                                    )
                                                                }
                                                                to={{
                                                                    pathname:
                                                                        child.link,
                                                                }}
                                                                className="flex items-center py-2 gap-6 hover:bg-[#2B3139AA] group"
                                                                key={index}
                                                            >
                                                                {child.icon}
                                                                <div className="flex flex-col">
                                                                    <span>
                                                                        {
                                                                            child.title
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </LinkWithSearchParams>
                                                        );
                                                }
                                            )}
                                        </div>
                                    </span>
                                );
                            }
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingHeader;
